export default __webpack_public_path__ + "9b906a6702af2bd73c2d865b4e6bad89.png";